import styled from "styled-components"

export const Message = styled.div`
  background-color: var(--very-light-gray);
  padding: 20px;
  border-radius: 20px;
`
